import { MoiCommentModel } from "@app/moi/shared/moi-comment-model";

export class MoiDueDateUpdateModel {
    newDate: Date;
    comment: MoiCommentModel;
}